export const SET_STRUCTURE = 'SET_STRUCTURE';
export function setStructure(structure_id) {
  return {
    type: SET_STRUCTURE,
    structure: structure_id,
  };
}

export const TOGGLE_EXTRA_STRUCTURE_BOX_FIELD = 'TOGGLE_EXTRA_STRUCTURE_BOX_FIELD';
export function toggleExtraStructureBoxField(field_id) {
  return {
    type: TOGGLE_EXTRA_STRUCTURE_BOX_FIELD,
    field: field_id,
  };
}

export const SET_EXTRA_STRUCTURE_BOX_FIELDS = 'SET_EXTRA_STRUCTURE_BOX_FIELDS';
export function setExtraStructureBoxFields(fields) {
  return {
    type: SET_EXTRA_STRUCTURE_BOX_FIELDS,
    fields,
  };
}

export const PUT_CUSTOM_EXTRA_FIELDS_IN_STORE = 'PUT_CUSTOM_EXTRA_FIELDS_IN_STORE';
export function putCustomExtraFieldsInStore(fields) {
  return {
    type: PUT_CUSTOM_EXTRA_FIELDS_IN_STORE,
    fields,
  };
}

export const TOGGLE_EXTRA_RELAY_BOX_FIELD = 'TOGGLE_EXTRA_RELAY_FIELD';
export function toggleExtraRelayBoxField(field_id) {
  return {
    type: TOGGLE_EXTRA_RELAY_BOX_FIELD,
    field: field_id,
  };
}

export const SET_EXTRA_RELAY_BOX_FIELDS = 'SET_EXTRA_RELAY_FIELDS';
export function setExtraRelayBoxFields(fields) {
  return {
    type: SET_EXTRA_RELAY_BOX_FIELDS,
    fields,
  };
}

export const SET_SCHEDULE_VIEW = 'SET_SCHEDULE_VIEW';
export function setScheduleView(view) {
  return {
    type: SET_SCHEDULE_VIEW,
    view,
  };
}
